import React, { useState } from "react";
import { Link } from "react-router-dom";

const PrivacyPolicy = ({ customContent, renderCustomHeader }) => {
  const [language, setLanguage] = useState("en"); // 기본 언어: 영어

  // 언어별 내용
  const content = customContent || {
    en: {
      title: "Privacy Policy",
      lastUpdated: "Last Updated: April 2, 2025",
      collectInfo: "1. Information We Collect",
      collectDescription:
        "Currently, we do not collect any personal information. However, in future updates, we may collect schedule data entered by users, including:",
      collectList: [
        "Event titles and descriptions entered by users",
        "Event dates and times",
        "Analysis results related to user interests",
      ],
      usagePurpose: "2. Purpose of Information Use",
      usageDescription: "Collected information may be used for:",
      usageList: [
        "Providing personalized advertisements",
        "Improving event recommendation features",
        "Enhancing service quality through data analysis",
      ],
      dataSharing: "3. Data Sharing & Third-Party Disclosure",
      sharingDescription:
        "User data is not shared externally by default. However, anonymized data may be shared with advertising partners (e.g., Google AdMob) to provide personalized ads.",
      dataStorage: "4. Data Retention & Deletion",
      storageDescription:
        "User schedule data is stored for service operation. Users can request to delete their schedule data or their account at any time.",
      contact: "5. Contact",
      contactDescription: "For inquiries, please contact (your@email.com).",
      changeLang: "Change to Korean",
    },
    ko: {
      title: "개인정보처리방침",
      lastUpdated: "최종 업데이트 날짜: 2025년 4월 2일",
      collectInfo: "1. 수집하는 정보",
      collectDescription:
        "현재 앱은 어떠한 개인정보도 수집하지 않습니다. 그러나 향후 업데이트에서 사용자가 입력한 일정 데이터를 수집할 수 있습니다:",
      collectList: [
        "사용자가 입력한 일정 제목 및 내용",
        "일정의 날짜 및 시간",
        "사용자의 관심사와 관련된 일정 데이터 분석 결과",
      ],
      usagePurpose: "2. 정보 이용 목적",
      usageDescription: "수집된 정보는 다음과 같은 목적으로 활용될 수 있습니다:",
      usageList: [
        "개인 맞춤형 광고 제공",
        "앱 내 일정 추천 기능 개선",
        "서비스 품질 향상을 위한 데이터 분석",
      ],
      dataSharing: "3. 정보 공유 및 제3자 제공",
      sharingDescription:
        "사용자의 데이터는 원칙적으로 외부에 제공되지 않습니다. 다만, 개인 맞춤형 광고를 제공하기 위해 익명화된 데이터를 광고 파트너(예: Google AdMob)와 공유할 수 있습니다.",
      dataStorage: "4. 데이터 보관 및 삭제",
      storageDescription:
        "사용자의 일정 데이터는 서비스 제공을 위해 일정 기간 동안 보관됩니다. 사용자는 언제든지 자신의 일정 데이터를 삭제하거나, 계정 삭제 요청을 할 수 있습니다.",
      contact: "5. 연락처",
      contactDescription: "문의 사항이 있으면 이메일 (your@email.com)로 연락주세요.",
      changeLang: "영어로 변경",
    },
  };

  console.log("Received customContent:", customContent);

  return (
    <div style={{ padding: "20px", maxWidth: "800px", margin: "0 auto", fontFamily: "Arial, sans-serif" }}>
      {/* Use the custom header if provided, otherwise render the default language button */}
      {renderCustomHeader ? (
        renderCustomHeader(language, setLanguage, content)
      ) : (
        <button 
          onClick={() => setLanguage(language === "en" ? "ko" : "en")}
          style={{ 
            padding: "8px 12px", 
            backgroundColor: "#4527A0", 
            color: "white", 
            border: "none", 
            borderRadius: "4px", 
            cursor: "pointer",
            marginBottom: "20px"
          }}
        >
          {content[language].changeLang}
        </button>
      )}

      <h1 style={{ color: "#000000" }}>{content[language].developer}</h1>
      <h1 style={{ color: "#4527A0" }}>{content[language].title}</h1>
      <p style={{ fontStyle: "italic", color: "#666" }}>{content[language].lastUpdated}</p>

      {/* Actually render the content */}
      <h2 style={{ color: "#333" }}>{content[language].collectInfo}</h2>
      <p>{content[language].collectDescription}</p>
      <ul>
        {content[language].collectList.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>

      <h2 style={{ color: "#333" }}>{content[language].usagePurpose}</h2>
      <p>{content[language].usageDescription}</p>
      <ul>
        {content[language].usageList.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>

      <h2 style={{ color: "#333" }}>{content[language].dataSharing}</h2>
      <p>{content[language].sharingDescription}</p>

      <h2 style={{ color: "#333" }}>{content[language].dataStorage}</h2>
      <p>{content[language].storageDescription}</p>

      <h2 style={{ color: "#333" }}>{content[language].contact}</h2>
      <p>{content[language].contactDescription}</p>

      <div style={{ marginTop: "30px", textAlign: "center" }}>
        <Link to="/" style={{
          textDecoration: "none",
          color: "#4527A0",
          fontWeight: "bold",
          fontSize: "14px"
        }}>
          ← Back to App Selection
        </Link>
      </div>
    </div>
  );
};

export default PrivacyPolicy;